import React, { useEffect, useState } from "react";
import styles from "../HeaderModuleYotpo/HeaderModuleYotpo.module.scss";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { generalConstants } from "@/utils/constants";

export default function HeaderModuleYotpo(props) {
  {
    const isMobile = useMediaQuery("(max-width: 767px)");
    const isTablet = useMediaQuery("(min-width:768px) and (max-width:1024px)");
    const [promoImage, setPromoImage] = useState("");
    
    useEffect(() => {
      if (isMobile) {
        if (props.user_loggedIn) {
          setPromoImage(generalConstants.yotpo_promo_signedin_mobile);
        }
        else {
          setPromoImage(generalConstants.yotpo_promo_signedout_mobile);
        }
      }
      else if (isTablet) {
        if (props.user_loggedIn) {
          setPromoImage(generalConstants.yotpo_promo_signedin_tablet);
        }
        else {
          setPromoImage(generalConstants.yotpo_promo_signedout_tablet);
        }
      }
      else {
        if (props.user_loggedIn) {
          setPromoImage(generalConstants.yotpo_promo_signedin_desktop);
        }
        else {
          setPromoImage(generalConstants.yotpo_promo_signedout_desktop);
        }
      }
        
    }, [isMobile, isTablet, props.user_loggedIn]);
      
      return (
        <>
          <div className={`${styles.rewards_header} ${props.user_loggedIn ? styles.logged_in : ""}`}>
          {/* promotion images*/}
          {/* <img className={`${isMobile?"mobile":isTablet?"tablet":"desktop"}`} src={promoImage} alt="rewards"/>  */}
  
           {/* Desktop View */}
            {!isMobile && (
              <img className="" src={props.yotpo_hero_image} alt="rewards"/> 
            )}
            
            {/* Mobile View */}
            {isMobile && (
              <img className="" src={props.yotpo_hero_image_mobile} alt="rewards"/> 
            )}     
            {props.user_loggedIn ? <h1 className="heading-medium">OLIVELA REWARDS <br />
              PROGRAM</h1>: !isMobile ? <h1 className="heading-medium">OLIVELA REWARDS PROGRAM</h1>: <h1 className="heading-medium">OLIVELA REWARDS <br />
              PROGRAM</h1>}
            <div className={`${styles.sub_title} large-xs large-sm large-md`}>An impactful rewards program unlike any other</div>
          </div>
        </>
      );
  }
}
